// extracted by mini-css-extract-plugin
module.exports = {"container":"PropertiesPagination-hashed__container__22mtB"};